var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "dialog-class": _vm.modalData?.className,
        scrollable: "",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
        "no-close-on-esc": _vm.modalData?.noClose,
        "no-close-on-backdrop": _vm.modalData?.noClose,
      },
      on: {
        hide: function ($event) {
          return _vm.$emit("hide")
        },
        hidden: function ($event) {
          return _vm.$emit("hidden")
        },
      },
    },
    [
      0 < _vm.modalData?.title?.length
        ? _c("div", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.modalData?.title) },
          })
        : _vm._e(),
      0 < _vm.modalData?.content?.length
        ? _c("div", {
            staticClass: "base-modal-content",
            domProps: { innerHTML: _vm._s(_vm.modalData?.content) },
          })
        : _vm._e(),
      _vm.modalData?.closeBtn
        ? _c(
            "button",
            {
              staticClass: "close-btn",
              on: { click: () => _vm.$bvModal.hide(_vm.id) },
            },
            [
              _c("img", {
                attrs: {
                  src: `${_vm.$s3}/img/common/modal/${_vm.modalData?.closeBtn}.webp?${_vm.$ver}`,
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._t("default"),
      _vm.modalData?.btns
        ? _c(
            "div",
            {
              staticClass: "btn-wrapper",
              class: {
                "cancel-on": _vm.modalData?.cancel && _vm.modalData?.submit,
              },
            },
            [
              _vm.modalData?.cancel
                ? _c(
                    "button",
                    {
                      staticClass: "modal-btn cancel",
                      attrs: {
                        id: "modal-cancel-btn",
                        disabled: _vm.cancelDisabled,
                      },
                      on: {
                        click: function ($event) {
                          _vm.modalData?.cancel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.modalData?.cancelTxt) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.modalData?.submit
                ? _c(
                    "button",
                    {
                      staticClass: "modal-btn confirm",
                      attrs: {
                        id: "modal-confirm-btn",
                        disabled: _vm.submitDisabled,
                      },
                      on: {
                        click: function ($event) {
                          _vm.modalData?.submit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.modalData?.submitTxt) + "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }